define( [
	"./document"
], function( document ) {
	"use strict";

	return document.documentElement;
} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/var/documentElement.js
// module id = 325
// module chunks = 0